import React from 'react';
import {  Container } from 'reactstrap';
import ImageView from './components/ImageView';

const DaicomViewer = (props ) =>{
    //console.log(props);
    return(
        <ImageView data={props.location.state.dataImg} dataPatient={props.location.state.dataPatient} pageIndex={props.location.state.pageIndex} />
    );
};

export default DaicomViewer;